import EventLayout from "components/Layout/EventLayout";
import { lang } from "constant/lang";
import useAuth from "hooks/useAuth";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import actionApi from "services/actionApi";

const MCCPage = () => {
  const event = lang.events.mcc;
  const { isAuth } = useAuth();
  const [isLoading, setIsLoading] = useState(true);
  const [isJoin, setIsJoin] = useState(false);

  useEffect(() => {
    if (!isAuth) {
      return;
    }
    actionApi
      .MCCCheck()
      .then((response) => {
        const isJoin = response?.data?.is_join_mcc;
        setIsJoin(isJoin);
      })
      .catch()
      .finally(() => {
        setIsLoading(false);
      });
  }, [isAuth]);

  return (
    <EventLayout
      event={event}
      isLoading={isLoading}
      isAuth={isAuth}
      isJoin={isJoin}
      isClosed={true}
    />
  );
};

export default MCCPage;
